var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartsUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_43_11201)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1565 12.577H9.55943C9.06303 12.577 8.66016 12.9799 8.66016 13.4763V21.5697C8.66016 22.0661 9.06303 22.469 9.55943 22.469H13.1565C13.6529 22.469 14.0558 22.0661 14.0558 21.5697V13.4763C14.0558 12.9799 13.6529 12.577 13.1565 12.577Z",
    fill: "#08A98A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.06276 16.1741H1.46568C0.96928 16.1741 0.566406 16.577 0.566406 17.0734V21.5697C0.566406 22.0661 0.96928 22.469 1.46568 22.469H5.06276C5.55916 22.469 5.96204 22.0661 5.96204 21.5697V17.0734C5.96204 16.577 5.55916 16.1741 5.06276 16.1741Z",
    fill: "#08A98A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2503 8.97992H17.6532C17.1568 8.97992 16.7539 9.38279 16.7539 9.87919V21.5697C16.7539 22.0661 17.1568 22.469 17.6532 22.469H21.2503C21.7467 22.469 22.1495 22.0661 22.1495 21.5697V9.87919C22.1495 9.38279 21.7467 8.97992 21.2503 8.97992Z",
    fill: "#08A98A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9939 9.6157L17.653 3.95659V7.18138H19.4516V1.78575C19.4516 1.28935 19.0487 0.886475 18.5523 0.886475H13.1567V2.68502H16.3815L11.3581 7.70835L8.39683 4.74705C8.04522 4.39543 7.47688 4.39543 7.12526 4.74705L2.62891 9.24341L3.90048 10.515L7.76105 6.6544L10.7224 9.6157C11.074 9.96732 11.6423 9.96732 11.9939 9.6157Z",
    fill: "#08A98A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_43_11201"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.5825,
    height: 21.5825,
    fill: "white",
    transform: "translate(0.566406 0.886475)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartsUp);
export default __webpack_public_path__ + "static/media/charts-up.3e8a06f462a6a8af5b9c15b787438a92.svg";
export { ForwardRef as ReactComponent };